<template>
  <div class="main-head" :class="{ mobile: mobile }">
    <div class="reminder-container">
      <div class="title">{{ $t('propTrade.reminder.title') }}</div>
      <div class="narrative">{{ $t('propTrade.reminder.narrative') }}</div>
    </div>
    <el-button class="blue_button verify-now-button" type="primary" @click="verifyNow" data-testid="verifyNow">
      <div class="verify-now-button-text">
        <div>{{ $t('propTrade.button.verifyNow') }}</div>
      </div>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'Reminder',
  props: {
    containerWidth: {
      type: Number | String,
      default: 0
    }
  },
  computed: {
    mobile() {
      return this.containerWidth <= 700;
    }
  },
  methods: {
    async verifyNow() {
      // await this.$router.push({ name: 'myProfile' }).catch(() => {});
      await this.$router.push({ name: 'register' }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.main-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 36px;
  background-color: #f2f6ff;
  padding: 20px 18px;
  border-radius: 8px;
}
.reminder-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  .title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .narrative {
    margin-top: 2px;
    font-size: 12px;
    font-weight: 400;
  }
}
.verify-now-button {
  width: fit-content;
  max-width: 164px;
  border-radius: 33px;
  &-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
}

// mobile style
.main-head.mobile {
  flex-direction: column;
  gap: 12px;

  .reminder-container {
    width: 100%;
  }

  .verify-now-button {
    max-width: unset;
    width: 100%;
    &-text {
      font-size: 12px;
    }
  }
}
</style>
